import { Box } from '@mui/material';

import { Callout } from '@/components/notifications/Callout/Callout';
import { EntityBeneficiariesSubform } from '@/modules/entities/EntityBeneficiariesSubform/EntityBeneficiariesSubform';
import { BENEFICIARIES_SUBFORM } from '@/modules/entities/EntityBeneficiariesSubform/EntityBeneficiariesSubform.constants';
import { useHouseholdDetailsContext } from '@/modules/household/contexts/householdDetails.context';
import { AiSuggestionKind } from '@/types/schema';

const { FormComponent: BeneficiariesFormComponent } =
  new EntityBeneficiariesSubform();

export function AccessAfterDeathSection() {
  const { householdId, isTwoClientHousehold } = useHouseholdDetailsContext();

  return (
    <>
      <Box pb={3}>
        <Callout severity="info-high">
          {isTwoClientHousehold
            ? 'Access during the lifetime of the surviving spouse.'
            : "Access after the client's death if the sub-trust continues to exist."}
        </Callout>
      </Box>
      <BeneficiariesFormComponent
        variant="testamentaryEntity"
        householdId={householdId!}
        namespace={BENEFICIARIES_SUBFORM}
        suggestionKindOverride={AiSuggestionKind.SubtrustLifetimeBeneficiary}
      />
    </>
  );
}
